import {$} from '../jquery-definition.js';
import 'jquery.equalheights';
import 'dotdotdot';

$( function() {
	$( '.equal-heights' ).equalHeights( {
		wait: true,
		watch: true
	} );

	$( '.image-block, .colored-block' ).prev( '.image-block' ).addClass( 'pre-image-block' );

	$( '.dotdotdot' ).dotdotdot( {} );

	$( '.overflow-x-scroll' ).each( function() {
		var $this = $( this );

		var width = $this.width();
		var innerWidth = $this[ 0 ].scrollWidth;

		if ( innerWidth > width ) {
			$( '<div class="scroll-indicator-background"></div>' ).insertAfter( $this );
			$( '<div class="scroll-indicator"></div>' ).insertAfter( $this );

			var scrollWidth = innerWidth - width;

			var $scrollIndicator = $this.next( '.scroll-indicator' );
			var scrollIndicatorRelativeWidth = (100 / innerWidth) * width;
			$scrollIndicator.width( scrollIndicatorRelativeWidth + '%' );
			var scrollIndicatorWidth = width * width / innerWidth;


			$this.on( 'scroll', function() {
				var scrollLeft = $( this ).scrollLeft();
				var foo = scrollLeft / (innerWidth - width);
				var scrollIndicatorOffset = foo * (width - scrollIndicatorWidth);

				$scrollIndicator.css( {
					'margin-left': scrollIndicatorOffset + 'px'
				} )
			} );
		}
	} );
} );
